import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
	   max-width: 480px;
	   width: 100%;

	   .authSelect,
	   .select {
	      margin-bottom: 10px;
	   }

	 

	   .select h4 {
	      margin-right: 0;
	      width: 84px;
	   }

	   .select > div {
	      min-width: 0;
	   }

	      .action {
      position: relative;
      display: flex;
      gap: 7.5px;
      align-items: center;
      padding-bottom: 10px;
      margin-bottom: 11px;

      &::after {
         content: '';
         position: absolute;
         left: 0;
         bottom: 0;
         width: 100%;
         height: 0.5px;
         background-color: rgb(220, 220, 220);
      }
      .btn1 {
         margin-top: 3px;
      }
   }

	   .action .danger {
	      border-color: #fecaca;
	      color: #b91c1c;
	   }

	   .status,
	   .message {
	      font-size: 13px;
	      line-height: 1.35;
	      margin: 8px 0;
	      color: #696f74;
	      word-break: break-word;
	   }

	   .status.connected {
	      color: #059669;
	   }

	   .status.error,
	   .message {
	      color: #dc2626;
	   }

	   .webhook-section {
	      margin-bottom: 12px;
   }

   .webhook-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      margin-bottom: 6px;
   }

   .webhook-section h4 {
      margin: 0;
      color: #333;
      font-size: 16px;
      font-weight: 600;
   }

   .toggle-btn {
      flex-shrink: 0;
   }

   .link-container {
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 8px;
      background: #f9f9f9;
      cursor: pointer;
      max-width: 100%;
      overflow: hidden;
   }

   .link-with-copy {
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0; /* Important for text truncation */
   }

   .copy-icon {
      color: #666;
      font-size: 12px;
      flex-shrink: 0;
   }

   .copy-icon.copied {
      color: #10b981;
   }

   .link-text {
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 14px;
      color: #333;
      word-break: break-all;
      overflow-wrap: break-word;
      white-space: normal;
      min-width: 0;
      flex: 1;
   }

   .instructions-section {
      margin: 12px 0;
   }

   .instructions-section h5 {
      margin: 0 0 8px 0;
      color: #333;
      font-size: 14px;
      font-weight: 600;
   }

   .steps-list {
      margin: 0;
      padding-left: 16px;
      font-size: 14px;
      line-height: 1.3;
   }

   .steps-list li {
      margin-bottom: 6px;
   }

   .external-link {
      color: #007bff;
      text-decoration: none;
      font-size: 14px;
      display: inline-flex;
      align-items: center;
      gap: 4px;
   }
`;
export const Loader = styled.span`
   width: 68px;
   height: 68px;
   border: 5px solid #9ca3af;
   border-bottom-color: transparent;
   border-radius: 50%;
   display: block;
   box-sizing: border-box;
   animation: rotation 1s linear infinite;
   margin: 0 auto;

   @keyframes rotation {
      0% {
         transform: rotate(0deg);
      }
      100% {
         transform: rotate(360deg);
      }
   }
`;
